import React, { useEffect, useState, useRef } from 'react';

const IconX = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
);

const IconLoader = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}>
    <line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/>
  </svg>
);

const IconCheck = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
);

const IconSheet = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/></svg>
);

function ProgressToast({ isOpen, onClose, progress = 0, message, isComplete = false, totalRows }) {
  const [isVisible, setIsVisible] = useState(false);
  const [elapsedSec, setElapsedSec] = useState(0);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && !isComplete) {
      if (startTimeRef.current === null) {
        startTimeRef.current = Date.now();
        setElapsedSec(0);
      }
      const interval = setInterval(() => {
        if (startTimeRef.current !== null) {
          setElapsedSec(Math.floor((Date.now() - startTimeRef.current) / 1000));
        }
      }, 1000);
      return () => clearInterval(interval);
    } else if (isComplete || !isOpen) {
      startTimeRef.current = null;
    }
  }, [isOpen, isComplete]);

  useEffect(() => {
    if (isComplete && progress >= 100) {
      const timer = setTimeout(() => onClose && onClose(), 2000);
      return () => clearTimeout(timer);
    }
  }, [isComplete, progress, onClose]);

  if (!isOpen) return null;

  // PROGRESO SEMÁNTICO (2026-06-07): el progreso real ahora viene del caller en pasos
  // discretos (10/30/80/100). No más extrapolación time-based que se quedaba colgada
  // en ~67% durante 30s+ (caso real: SQL de 86s, ETA fake estimaba 6s).
  // Si NO recibimos `progress` explícito, no inventamos — barra animada (pulse).
  const displayedProgress = isComplete ? 100 : (typeof progress === 'number' ? progress : 0);
  const showPulse = !isComplete && (progress === 0 || progress < 5);

  const wrap = {
    position: 'fixed', bottom: 16, right: 16, zIndex: 1000,
    transition: 'all 300ms',
    transform: isVisible ? 'translateY(0)' : 'translateY(8px)',
    opacity: isVisible ? 1 : 0,
  };
  const card = {
    background: '#fff', borderRadius: 8, boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
    border: '1px solid #e5e7eb', padding: 16, minWidth: 340, maxWidth: 420,
  };

  return (
    <div style={wrap}>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      <div style={card}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ color: isComplete ? '#16a34a' : '#16a34a' }}>
              {isComplete ? <IconCheck /> : <IconLoader />}
            </div>
            <div>
              <h4 style={{ margin: 0, fontWeight: 500, color: '#111827', fontSize: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
                {isComplete ? 'Exportación completada' : 'Exportando a Excel'}
                {!isComplete && <span style={{ color: '#16a34a' }}><IconSheet /></span>}
              </h4>
              {message && <p style={{ margin: '4px 0 0', fontSize: 13, color: '#4b5563' }}>{message}</p>}
              {!isComplete && totalRows !== undefined && totalRows > 0 && (
                <p style={{ margin: '4px 0 0', fontSize: 11, color: '#6b7280' }}>
                  {totalRows.toLocaleString('es-AR')} productos
                </p>
              )}
            </div>
          </div>
          <button onClick={onClose} style={{ border: 'none', background: 'transparent', color: '#9ca3af', cursor: 'pointer', padding: 4 }}>
            <IconX />
          </button>
        </div>

        {!isComplete && (
          <div style={{ marginTop: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#4b5563', marginBottom: 4 }}>
              <span>Progreso</span>
              <span>{showPulse ? '...' : `${Math.round(displayedProgress)}%`}</span>
            </div>
            <div style={{ width: '100%', background: '#e5e7eb', borderRadius: 999, height: 8, overflow: 'hidden', position: 'relative' }}>
              {showPulse ? (
                <div style={{
                  background: '#16a34a', height: '100%', borderRadius: 999,
                  width: '40%', position: 'absolute', left: 0,
                  animation: 'progressPulse 1.4s ease-in-out infinite',
                }} />
              ) : (
                <div style={{ background: '#16a34a', height: '100%', borderRadius: 999, width: `${displayedProgress}%`, transition: 'width 400ms ease-out' }} />
              )}
            </div>
            <style>{`@keyframes progressPulse { 0% { transform: translateX(-100%); } 100% { transform: translateX(250%); } }`}</style>
            {elapsedSec > 0 && (
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>Transcurrido: {elapsedSec}s</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProgressToast;
